module.exports = __webpack_public_path__ + "static/media/scan-mask.e1ab90bf.svg";